var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFunCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F0CD00;}\r\n\t.st1{fill:#FFDE50;}\r\n\t.st2{fill:#FFEA94;}\r\n\t.st3{fill:#FAA300;}\r\n\t.st4{fill:#FFBD00;}\r\n\t.st5{fill:#F68E00;}\r\n\t.st6{fill:#EAEAEA;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M512,256c0,141.4-114.6,256-256,256c-74.5,0-141.6-31.8-188.4-82.7c-12.3-13.3-23.2-28-32.4-43.7 C12.8,347.6,0,303.3,0,256C0,114.6,114.6,0,256,0c47.3,0,91.6,12.8,129.6,35.2c15.7,9.2,30.4,20.1,43.7,32.4 C480.1,114.4,512,181.5,512,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M512,256c0,138.2-109.5,250.8-246.5,255.8c-137-5-246.5-117.6-246.5-255.8S128.6,5.2,265.5,0.2 C402.5,5.2,512,117.8,512,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M429.3,67.6L67.6,429.3c-12.3-13.3-23.2-28-32.4-43.7L385.6,35.2C401.3,44.4,416,55.3,429.3,67.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M494.3,162.4L162.4,494.4c-23.5-9.2-45.3-21.8-64.8-37.2L457.1,97.6C472.5,117.1,485.1,138.9,494.3,162.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M454.9,256c0,109.9-89.1,198.9-198.9,198.9c-38.3,0-74-10.8-104.3-29.5c-13.2-8.1-25.4-17.8-36.3-28.7 c-8-8-15.4-16.8-22-26.1c-9-12.8-16.6-26.8-22.5-41.6c-8.7-21.9-13.5-45.7-13.8-70.6c0-0.8,0-1.6,0-2.4 c0-109.9,89.1-198.9,198.9-198.9c0.8,0,1.6,0,2.5,0c24.9,0.3,48.7,5.2,70.6,13.8c14.8,5.9,28.7,13.4,41.6,22.5 c9.3,6.6,18,13.9,26.1,22c10.9,10.9,20.6,23.1,28.7,36.3C444.1,182,454.9,217.7,454.9,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M396.7,115.3L115.3,396.7c-8-8-15.4-16.8-22-26.1c-9-12.8-16.6-26.8-22.5-41.6c-8.7-21.9-13.5-45.7-13.8-70.6 c0-0.8,0-1.6,0-2.4c0-109.9,89.1-198.9,198.9-198.9c0.8,0,1.6,0,2.5,0c24.9,0.3,48.7,5.2,70.6,13.8c14.8,5.9,28.7,13.4,41.6,22.5 C379.9,100,388.6,107.3,396.7,115.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M454.9,256c0,109.9-89.1,198.9-198.9,198.9c-3.8,0-7.5-0.1-11.2-0.3c104.6-5.8,187.7-92.5,187.7-198.6 s-83-192.8-187.7-198.6c3.7-0.2,7.5-0.3,11.2-0.3C365.9,57.1,454.9,146.1,454.9,256z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.5,245c0-29.5,19.2-53.4,48.4-56.7l4.1-30.1l-4.1-31C193,130.1,140.4,174.3,140.4,245 c0,70.6,53,115.2,119.2,117.9l2-27.4l-2-33.7C229.9,298.8,210.5,274.7,210.5,245z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M265.9,187.9c19.5,0,34.5,10.9,42.1,25l58.1-29.8c-15.7-29.4-47.2-56.1-100.2-56.1c-2.6,0-5.1,0.1-7.6,0.2 v61.2C260.7,188.1,263.3,187.9,265.9,187.9L265.9,187.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M259,225.2v56.8h44.1v9.9c-8.9,6.5-22.6,10.3-37.3,10.3c-2.6,0-5.1-0.2-7.6-0.5v61.2 c2.5,0.1,5.1,0.2,7.6,0.2c44.8,0,79-18.1,104.3-46.2v-91.7L259,225.2L259,225.2z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunCoin);
export default __webpack_public_path__ + "static/media/fun-coin.2aca5c5141f17934f21a0ca71f9cebb6.svg";
export { ForwardRef as ReactComponent };